import { render, staticRenderFns } from "./BalanceContainer.vue?vue&type=template&id=2cbf21f1&scoped=true&"
import script from "./BalanceContainer.vue?vue&type=script&lang=ts&"
export * from "./BalanceContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceContainer.vue?vue&type=style&index=0&id=2cbf21f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf21f1",
  null
  
)

export default component.exports